import { render, staticRenderFns } from "./QuotationStepFile.vue?vue&type=template&id=277e9aa2&scoped=true"
import script from "./QuotationStepFile.vue?vue&type=script&lang=js"
export * from "./QuotationStepFile.vue?vue&type=script&lang=js"
import style0 from "./QuotationStepFile.vue?vue&type=style&index=0&id=277e9aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277e9aa2",
  null
  
)

export default component.exports